import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'DigitalWorks Consulting Group';
const SITE_TAGLINE = 'AI-native transformation & engineering consulting partner';
const DEFAULT_DESCRIPTION =
  'DigitalWorks is an AI-native transformation and engineering consulting partner. We advise, build and operate AI-native products for global retail, luxury and consumer groups.';
const DEFAULT_OG = '/og-default.png';

/**
 * Per-page SEO block. Accepts title/description/canonical/ogImage; falls back
 * to sensible site-wide defaults. Titles automatically get the site suffix
 * unless suffix={false} is passed.
 */
export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  canonical,
  ogImage = DEFAULT_OG,
  type = 'website',
  suffix = true,
}) {
  const fullTitle = title
    ? suffix
      ? `${title} — ${SITE_NAME}`
      : title
    : `${SITE_NAME} — ${SITE_TAGLINE}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      {canonical && <meta property="og:url" content={canonical} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
